<div [ngClass]="{'ng-invalid ng-dirty': isCurrentlyInvalid}">
	<label>{{ 'form.field.company' | translate }}<span *ngIf="required" class="text-danger">*</span></label>
	<p-dropdown [options]="companyList" optionLabel="company_display_label" optionValue="company_id"
		[(ngModel)]="_value" [inputId]="controlName" placeholder="{{ 'form.field.companyPlaceholder' | translate }}"
		(onChange)="onCompanySelectionChange($event.value)" (onBlur)="propagateTouched()" [filter]="true"
		filterBy="company_name_en,company_name_ar,company_name_he" [showClear]="false" [disabled]="_disabled"
		[styleClass]="isCurrentlyInvalid ? 'p-invalid w-100' : 'w-100'">
		<ng-template let-item pTemplate="item">
			{{ getCompanyName(item) }}
		</ng-template>
		<ng-template let-item pTemplate="selectedItem">
			{{ getCompanyName(item) }}
		</ng-template>
	</p-dropdown>
	<div *ngIf="isCurrentlyInvalid" class="invalid-feedback text-danger d-block">
		{{ currentErrorMessage }}
	</div>
</div>